import { useMemo } from 'react';
import type { ExpertReportBlockTreeNode } from './types';
import { useExpertReportsBlocksResponses } from './useExpertReportsBlocksResponses';

/** Соответствие reportId → дерево блоков экспертного заключения */
export type ExpertReportBlocksTreeMap = Map<number, ExpertReportBlockTreeNode[]>;

/**
 * Загружает деревья блоков для указанных экспертных заключений и возвращает
 * `reportId → дерево блоков` (без потери вложенности) — используется для построения вложенных
 * групп колонок блоков в таблице диалогов и для перечисления листовых блоков (видимость,
 * параметры запроса). Ещё не загруженного заключения в соответствии нет.
 */
export const useExpertReportsBlocksTree = (reportIds: number[]): ExpertReportBlocksTreeMap => {
  const responses = useExpertReportsBlocksResponses(reportIds);

  return useMemo(() => {
    const map: ExpertReportBlocksTreeMap = new Map();
    responses.forEach((response, reportId) => {
      map.set(reportId, response.blocks);
    });
    return map;
  }, [responses]);
};
